import React from "react";
import { Users as UsersIcon, GraduationCap, Layers, BookOpen, IndianRupee } from "lucide-react";
import SAStatCard from "../../Dashboard/SAStatCard";

/**
 * StatsTab — Quick aggregated stats for a single institute.
 */
const StatsTab = ({ institute }) => {
  const stats = institute.stats || {};

  return (
    <div className="sa-detail-tab">
      <div className="sa-grid-3" style={{ marginBottom: "1rem" }}>
        <SAStatCard
          title="Students"
          value={stats.totalStudents ?? institute.studentCount ?? 0}
          icon={UsersIcon}
          iconClass="blue"
        />
        <SAStatCard
          title="Batches"
          value={stats.totalBatches ?? 0}
          icon={Layers}
          iconClass="violet"
        />
        <SAStatCard
          title="Courses"
          value={stats.totalCourses ?? 0}
          icon={BookOpen}
          iconClass="emerald"
        />
      </div>
      <div className="sa-grid-3">
        <SAStatCard
          title="Instructors"
          value={stats.totalInstructors ?? 0}
          icon={GraduationCap}
          iconClass="amber"
        />
        <SAStatCard
          title="Revenue"
          value={`₹${((stats.totalRevenue ?? 0) / 1000).toFixed(0)}K`}
          icon={IndianRupee}
          iconClass="emerald"
        />
        <SAStatCard
          title="Admins"
          value={stats.totalAdmins ?? 0}
          icon={UsersIcon}
          iconClass="rose"
        />
      </div>
    </div>
  );
};

export default StatsTab;
